/** Frost blade (fx 'snow', 'icebreak'): a pale arc and a spray of snow, or ice, at the target. */
import { registerFx } from './registry';

registerFx(['snow', 'icebreak'], (host) => ({
  skill: ({ src, tgt, s, style, tx, ty }) => {
    host.swingArc(src, style, s.fx === 'icebreak' ? '170,230,255' : '220,240,255');
    if (tgt) host.snowBurst(tx, ty - 14 * host.tall(tgt), s.fx === 'snow' ? 12 : 20, s.fx === 'icebreak');
    host.sfx.swing();
  },
}));
